"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMomentFromMilitaryTime = exports.delay = exports.generateTimeSlots = exports.getNextXBusinessDays = exports.convertDays = exports.datetimeIsAfterHour = exports.isInPast = exports.isToday = exports.fetchTimezoneFromState = exports.businessDaysBetweenDates = exports.fetchFirstBusinessDayBeforeXDays = exports.fetchFirstBusinessDayAfterXDays = exports.isBusinessDay = exports.isWeekend = exports.isHoliday = exports.convertDateTimeToISO = exports.getLosAngelesTimeISOString = exports.constructIsoDateFromDayHourTimezone = exports.getTimeFromIsoDate = exports.getNextDay = exports.STANDARD_SERVICE_START_TIME = exports.STANDARD_SERVICE_END_TIME = exports.END_OF_BUSINESS_HOUR = exports.CHI_TIMEZONE = exports.NY_TIMEZONE = exports.LA_TIMEZONE = void 0;
const tslib_1 = require("tslib");
const date_holidays_1 = tslib_1.__importDefault(require("date-holidays"));
const lodash_1 = tslib_1.__importDefault(require("lodash"));
const moment_timezone_1 = tslib_1.__importDefault(require("moment-timezone"));
exports.LA_TIMEZONE = 'America/Los_Angeles';
exports.NY_TIMEZONE = 'America/New_York';
exports.CHI_TIMEZONE = 'America/Chicago';
exports.END_OF_BUSINESS_HOUR = 17;
const WEEKEND_DAYS = [6, 0];
exports.STANDARD_SERVICE_END_TIME = '5:00pm';
exports.STANDARD_SERVICE_START_TIME = '9:00am';
const dateHolidays = new date_holidays_1.default('US');
const IN_NETWORK_HOLIDAY_NAMES = [
    "New Year's Day",
    'Independence Day',
    'Christmas Day',
    'Thanksgiving Day',
    'Memorial Day',
    'Labor Day',
];
const OUT_OF_NETWORK_HOLIDAY_NAMES = [
    "New Year's Day",
    'Independence Day',
    'Christmas Eve',
    'Christmas Day',
    'Thanksgiving Day',
    'Day after Thanksgiving Day',
    'Memorial Day',
    'Labor Day',
];
const getNextDay = (isodate, timezone) => (0, moment_timezone_1.default)(isodate).tz(timezone).add(1, 'days').format();
exports.getNextDay = getNextDay;
const getTimeFromIsoDate = (isodate, timezone) => (0, moment_timezone_1.default)(isodate).tz(timezone).format('HH:mm');
exports.getTimeFromIsoDate = getTimeFromIsoDate;
const constructIsoDateFromDayHourTimezone = (day, timezone, hour) => (0, moment_timezone_1.default)(day).tz(timezone).hour(hour).toISOString();
exports.constructIsoDateFromDayHourTimezone = constructIsoDateFromDayHourTimezone;
const getLosAngelesTimeISOString = () => (0, moment_timezone_1.default)().tz(exports.LA_TIMEZONE).toISOString();
exports.getLosAngelesTimeISOString = getLosAngelesTimeISOString;
const convertDateTimeToISO = (dateTime) => {
    let createdAt = (0, moment_timezone_1.default)((0, moment_timezone_1.default)().toISOString()).toISOString();
    if (Number.isInteger(dateTime)) {
        if (dateTime < 1318781876406) {
            createdAt = moment_timezone_1.default.unix(dateTime).toISOString();
        }
        else {
            createdAt = (0, moment_timezone_1.default)(dateTime).toISOString();
        }
    }
    else if (dateTime) {
        createdAt = (0, moment_timezone_1.default)(dateTime).toISOString();
    }
    return createdAt;
};
exports.convertDateTimeToISO = convertDateTimeToISO;
const isHoliday = (dateString, { isInNetwork }) => {
    const [dateTextOnly] = dateString.split('T');
    const date = (0, moment_timezone_1.default)(dateTextOnly);
    const dateTimestamp = date.valueOf();
    if (dateTextOnly === '2021-07-05') {
        return true;
    }
    const holidays = getHolidays(date.year(), isInNetwork);
    const matchingHoliday = holidays.find((holiday) => {
        const [holidayDate] = holiday.date.split(' ');
        const start = (0, moment_timezone_1.default)(holidayDate).valueOf();
        const end = (0, moment_timezone_1.default)(holidayDate).add(1, 'day').valueOf();
        return start <= dateTimestamp && dateTimestamp < end;
    });
    return Boolean(matchingHoliday);
};
exports.isHoliday = isHoliday;
const isWeekend = (dateStr, { utcInput } = { utcInput: false }) => {
    const date = utcInput ? moment_timezone_1.default.utc(dateStr) : (0, moment_timezone_1.default)(dateStr).tz(exports.LA_TIMEZONE);
    return WEEKEND_DAYS.includes(date.day());
};
exports.isWeekend = isWeekend;
const isBusinessDay = (date, isInNetwork, { allowWeekendShipments, utcInput } = {}) => {
    const dateOnTimezone = (0, moment_timezone_1.default)(date).toISOString();
    return (!(0, exports.isHoliday)(dateOnTimezone, { isInNetwork }) &&
        (!(0, exports.isWeekend)(dateOnTimezone, { utcInput }) || Boolean(allowWeekendShipments)));
};
exports.isBusinessDay = isBusinessDay;
const fetchFirstBusinessDayAfterXDays = (date, days, timezone, { isInNetwork, allowWeekendShipments }) => {
    if (days < 0) {
        return 'null';
    }
    let infiniteLoopProtector = 0;
    let nextDay = date;
    while (days > 0 || !(0, exports.isBusinessDay)(nextDay, isInNetwork, { allowWeekendShipments })) {
        if ((0, exports.isBusinessDay)(nextDay, isInNetwork, { allowWeekendShipments })) {
            days -= 1;
        }
        nextDay = (0, exports.getNextDay)(nextDay, timezone);
        infiniteLoopProtector += 1;
        if (infiniteLoopProtector >= 100) {
            break;
        }
    }
    return nextDay;
};
exports.fetchFirstBusinessDayAfterXDays = fetchFirstBusinessDayAfterXDays;
const fetchFirstBusinessDayBeforeXDays = (date, days, timezone, { isInNetwork, allowWeekendShipments }) => {
    if (days < 0) {
        return 'null';
    }
    let infiniteLoopProtector = 0;
    let nextDay = date;
    while (days > 0 || !(0, exports.isBusinessDay)(nextDay, isInNetwork, { allowWeekendShipments })) {
        if ((0, exports.isBusinessDay)(nextDay, isInNetwork, { allowWeekendShipments })) {
            days -= 1;
        }
        nextDay = (0, moment_timezone_1.default)(nextDay).tz(timezone).subtract(1, 'days').format();
        infiniteLoopProtector += 1;
        if (infiniteLoopProtector === 100) {
            break;
        }
    }
    return nextDay;
};
exports.fetchFirstBusinessDayBeforeXDays = fetchFirstBusinessDayBeforeXDays;
const businessDaysBetweenDates = (fromDate, toDate, { isInNetwork }) => {
    if (!(0, moment_timezone_1.default)(fromDate).isValid()) {
        throw new Error(`Unable to determine business days between dates using invalid from date ${fromDate}`);
    }
    if (!(0, moment_timezone_1.default)(toDate).isValid()) {
        throw new Error(`Unable to determine business days between dates using invalid to date ${toDate}`);
    }
    if ((0, moment_timezone_1.default)(fromDate).isAfter(toDate) || (0, moment_timezone_1.default)(fromDate).isSame((0, moment_timezone_1.default)(toDate), 'day')) {
        return 0;
    }
    fromDate = (0, moment_timezone_1.default)(fromDate).toISOString();
    let businessDays = 0;
    let infiniteLoopProtector = 0;
    while (!(0, moment_timezone_1.default)(fromDate).isSame((0, moment_timezone_1.default)(toDate), 'day')) {
        infiniteLoopProtector += 1;
        if ((0, exports.isBusinessDay)(fromDate, isInNetwork, { utcInput: true })) {
            businessDays += 1;
        }
        fromDate = (0, moment_timezone_1.default)(fromDate).add(1, 'day').toISOString();
        if (infiniteLoopProtector === 100) {
            return 0;
        }
    }
    return businessDays;
};
exports.businessDaysBetweenDates = businessDaysBetweenDates;
const fetchTimezoneFromState = (state) => {
    switch (state) {
        case 'HI':
            return 'Pacific/Honolulu';
        case 'CA':
        case 'WA':
            return 'America/Los_Angeles';
        case 'AZ':
            return 'America/Phoenix';
        case 'CO':
        case 'MT':
        case 'NM':
        case 'UT':
        case 'WY':
            return 'America/Denver';
        case 'AL':
        case 'AR':
        case 'IL':
        case 'IA':
        case 'LA':
        case 'MN':
        case 'MO':
        case 'MS':
        case 'WI':
            return 'America/Chicago';
        case 'CT':
        case 'DE':
        case 'GA':
        case 'ME':
        case 'MD':
        case 'MA':
        case 'NH':
        case 'NJ':
        case 'NC':
        case 'NY':
        case 'OH':
        case 'PA':
        case 'RI':
        case 'SC':
        case 'VT':
        case 'VA':
        case 'WV':
            return 'America/New_York';
        default:
            return null;
    }
};
exports.fetchTimezoneFromState = fetchTimezoneFromState;
const isToday = (isodate, timezone) => (0, moment_timezone_1.default)(isodate).tz(timezone).isSame((0, moment_timezone_1.default)().tz(timezone), 'day');
exports.isToday = isToday;
const isInPast = (isodate, timezone) => (0, moment_timezone_1.default)(isodate).tz(timezone).isBefore((0, moment_timezone_1.default)().tz(timezone));
exports.isInPast = isInPast;
const datetimeIsAfterHour = (datetime, timezone, hour) => {
    const hourInGivenTimezone = (0, moment_timezone_1.default)(datetime).tz(timezone).hour();
    return hourInGivenTimezone >= hour;
};
exports.datetimeIsAfterHour = datetimeIsAfterHour;
const convertDays = (days, { floor = true } = {}) => {
    const MILLISECONDS_PER_DAY = 86400000;
    const milliseconds = MILLISECONDS_PER_DAY * (floor ? Math.floor(days) : days);
    return lodash_1.default.mapValues({
        days,
        hours: milliseconds / 1000 / 60 / 60,
        milliseconds,
        minutes: milliseconds / 1000 / 60,
        seconds: milliseconds / 1000,
    }, (value) => (floor ? Math.floor(value) : value));
};
exports.convertDays = convertDays;
const getNextXBusinessDays = (delta, startDate, timezone, { isInNetwork, allowWeekendShipments }) => {
    const businessDays = [];
    let day = (0, moment_timezone_1.default)(startDate).tz(timezone).format();
    let infiniteLoopProtector = 0;
    while (businessDays.length < delta) {
        if ((0, exports.isBusinessDay)(day, isInNetwork, { allowWeekendShipments })) {
            businessDays.push(day);
        }
        day = (0, exports.getNextDay)(day, timezone);
        infiniteLoopProtector += 1;
        if (infiniteLoopProtector >= 100) {
            break;
        }
    }
    return businessDays;
};
exports.getNextXBusinessDays = getNextXBusinessDays;
const generateTimeSlots = (start, end, duration) => {
    const response = [];
    if (start >= end) {
        return [];
    }
    if (duration > end - start) {
        response.push({ end, start });
        return response;
    }
    for (let i = start; i + duration <= end; i++) {
        response.push({ end: i + duration, start: i });
    }
    return response;
};
exports.generateTimeSlots = generateTimeSlots;
function getHolidays(year, inNetwork) {
    const names = inNetwork ? IN_NETWORK_HOLIDAY_NAMES : OUT_OF_NETWORK_HOLIDAY_NAMES;
    return dateHolidays.getHolidays(year).filter(({ name }) => names.includes(name));
}
function delay(milliseconds = 1000) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield new Promise((resolve) => setTimeout(resolve, milliseconds));
    });
}
exports.delay = delay;
const _parseHoursAndMinutesFromMilitaryTime = (militaryTime) => {
    const [hours, minutes] = militaryTime.split(':');
    if (lodash_1.default.isNil(hours) || lodash_1.default.isNil(minutes)) {
        throw new Error(`military time ${militaryTime} could not be parsed!`);
    }
    const parsedHours = Number.parseInt(hours, 10);
    const parsedMinutes = Number.parseInt(minutes, 10);
    if (isNaN(parsedHours) ||
        isNaN(parsedMinutes) ||
        parsedHours > 24 ||
        parsedHours < 0 ||
        parsedMinutes > 60 ||
        parsedMinutes < 0) {
        throw new Error(`military time ${militaryTime} could not be parsed!`);
    }
    return {
        hours: Number.parseInt(hours, 10),
        minutes: Number.parseInt(minutes, 10),
    };
};
const parseMomentFromMilitaryTime = ({ militaryTime, timezoneId, onDayOfUnixTimestamp = Date.now(), }) => {
    const { hours, minutes } = _parseHoursAndMinutesFromMilitaryTime(militaryTime);
    return (0, moment_timezone_1.default)(onDayOfUnixTimestamp).tz(timezoneId).set('hours', hours).set('minutes', minutes).set('seconds', 0);
};
exports.parseMomentFromMilitaryTime = parseMomentFromMilitaryTime;
//# sourceMappingURL=time.js.map